import React from 'react';
import { assetClassTour } from './builders';

// Investments overview + the asset-class landing pages.
export const OVERVIEW_TOURS = {
  investments: [
    {
      title: 'Welcome to Investments',
      body: (
        <>
          <p>Track everything you invest in, grouped into seven <b>asset classes</b>: Equity, Debt, Gold, Real Estate, Cash &amp; Liquid, Crypto and Others.</p>
          <p>Each class opens into products, such as Stocks or Fixed Deposits, where you add your holdings.</p>
        </>
      ),
    },
    {
      target: '[data-tour="inv-summary"]',
      title: 'Your portfolio',
      body: (
        <>
          <p><b>Total Investments</b> is everything you've invested, at the price you paid, plus your bank balances (counted under Cash &amp; Liquid).</p>
          <p><b>Most Valuable Asset Class</b> is where most of your money sits.</p>
        </>
      ),
    },
    {
      target: '[data-tour="inv-allocation"]',
      title: 'Asset Allocation',
      body: (
        <>
          <p>How much is in each asset class and its share of the total, largest first. Classes you haven't invested in yet are greyed out.</p>
          <p><b>Click a class</b> to open it and see its products.</p>
        </>
      ),
    },
    {
      target: '[data-tour="inv-distribution"]',
      title: 'Distribution',
      body: (
        <p>The same split as a chart, so you can see at a glance whether your money is spread the way you want. Hover or tap a slice for its amount.</p>
      ),
    },
    {
      title: 'Values are at cost',
      body: (
        <>
          <p>Totals on this page use <b>what you paid</b>. To see what your holdings are worth today, open a product: Stocks, ETFs, mutual funds, REITs and gold fetch <b>live prices</b> there.</p>
          <p>Replay this guide any time with the <b>Guide</b> button.</p>
        </>
      ),
      action: { label: 'Open Equity', to: '/investments/equity' },
    },
  ],

  'inv-equity': assetClassTour({
    name: 'Equity',
    intro: <p>Equity means owning a share of companies. It can grow the most over the long run, but its value goes up and down.</p>,
    products: [
      ['Stocks', 'shares of individual companies, with live prices and sell tracking'],
      ['Equity ETF', 'exchange-traded funds that hold a basket of shares'],
      ['Mutual Fund Equity', 'equity mutual funds, with live NAV'],
      ['NPS', 'the equity part of your National Pension System account'],
    ],
  }),

  'inv-debt': assetClassTour({
    name: 'Debt',
    intro: <p>Debt investments lend your money in return for interest. They're steadier than equity and usually pay a fixed or predictable return.</p>,
    products: [
      ['Fixed and Recurring Deposits', 'bank deposits, with maturity worked out for you'],
      ['EPF and PPF', 'provident funds'],
      ['Government and Corporate Bonds, NCDs', 'bonds and debentures'],
      ['Debt Mutual Funds', 'debt funds, with live NAV'],
      ['NPS Debt Component', 'the debt part of your NPS account'],
      ['Other Debt Investments', 'anything else that pays interest'],
    ],
  }),

  'inv-gold': assetClassTour({
    name: 'Gold',
    intro: <p>Gold in every form you might hold it, from coins and jewellery to bonds and funds. Digital and physical gold are valued at the live gold price.</p>,
    products: [
      ['Gold Bonds', 'Sovereign Gold Bonds, which also pay 2.5% a year'],
      ['Digital Gold', 'gold bought online by the gram'],
      ['Physical Gold', 'coins, bars and jewellery'],
      ['Gold ETF', 'gold exchange-traded funds'],
      ['Mutual Fund', 'gold mutual funds'],
    ],
  }),

  'inv-real-estate': assetClassTour({
    name: 'Real Estate',
    intro: <p>Property you own directly, and listed property trusts.</p>,
    products: [
      ['REIT', 'Real Estate Investment Trusts, traded like shares, with live prices'],
      ['Real Estate Direct', 'flats, houses and land you own, at the price you paid'],
    ],
  }),

  'inv-cash-and-liquid': assetClassTour({
    name: 'Cash & Liquid',
    intro: <p>Money you can get at quickly: your bank balances and very short-term funds.</p>,
    products: [
      ['Savings Bank', 'your bank account balances, taken from Wallets'],
      ['Liquid ETF', 'liquid exchange-traded funds'],
      ['Mutual Fund', 'liquid mutual funds, with live NAV'],
    ],
  }),
};
